import React from "react";
import { Bling as GPT } from "react-gpt";
import styles from "./GoogleAd.module.css";

GPT.enableSingleRequest();

const GoogleAd = (props) => {
  return (
    <div className={[styles.Ad, styles[props.additionalClass]].join(" ")}>
      <GPT
        adUnitPath="/61924087/graphics.suntimes.com/"
        sizeMapping={[
          { viewport: [0, 0], slot: [320, 50] },
          { viewport: [750, 0], slot: [728, 90] },
          { viewport: [1050, 0], slot: [728, 90] },
        ]}
      />
    </div>
  );
};

export default GoogleAd;
